module.exports = __webpack_public_path__ + "static/assets/695f0ba974a7fa018383557faa5f9725.png";